import {
  EngagementType,
  PhotoCarouselAdminConfig,
  PhotoCarouselAdminData,
} from '@/generated/graphql';
import { PhotoCarouselStageView } from './stage/stage-view';
import { PhotoCarouselFanView } from './fan/fan-view';
import { EngagementDefinition } from '../base/EngagementDefinition';
import { CameraIcon } from '@radix-ui/react-icons';
import { PhotoCarouselAdminControlView } from './admin/control-view';
import { PhotoCarouselEditorView } from './admin/editor-view';
import { DEFAULT_MAX_VISIBLE_PHOTOS } from './consts';
export const photoCarouselEngagementDefinition: EngagementDefinition<
  PhotoCarouselAdminConfig,
  PhotoCarouselAdminData
> = {
  enabled: true,
  title: 'Photo Share',
  Icon: CameraIcon,
  type: EngagementType.PhotoCarousel,
  stageComponent: PhotoCarouselStageView,
  fanComponent: PhotoCarouselFanView,
  adminEditorView: PhotoCarouselEditorView,
  adminControlView: PhotoCarouselAdminControlView,
  getInitialData: () => ({
    rejectedQueue: [],
    seenQueue: [],
    seenQueuePointer: 0,
    unseenQueue: [],
    unapprovedQueue: [],
  }),
  getInitialConfig: () => ({
    maxSubmissionsPerUser: 0,
    requireApproval: false,
    maxVisiblePhotos: DEFAULT_MAX_VISIBLE_PHOTOS,
  }),
};
